import { render, staticRenderFns } from "./OTextarea.vue?vue&type=template&id=39309906&scoped=true&"
import script from "./OTextarea.vue?vue&type=script&lang=js&"
export * from "./OTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39309906",
  null
  
)

export default component.exports